import React from 'react';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import HorizontalFormInput from '../../../../../components/FormHelpers/horizontalFormInput';

const RenderSelectedSuppliers = ({ options }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArray({
    control,
    name: 'selectedSuppliers'
  });

  if (options.length < 1) return null;

  return (
    <div className="card">
      <div className="card__body">
        {options.map(({ label }, i) => (
          <div className="supplier" key={i}>
            <HorizontalFormInput
              name={`selectedSuppliers.${i}.description`}
              control={control}
              label={`Bearbetning från ${label}`}
              placeholder={`Ange vad ${label} har gjort för typ av databehandling med involverade filer.`}
              renderAs="textarea"
              className="form-control textarea--no-resize"
              rows={2}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RenderSelectedSuppliers;
